@use '../../scss/utility/functions' as utility;

:host([direction='horizontal']:not(:first-child)) {
  margin-inline-start: utility.wb-pixel-to-rem(-1px);
}

:host([direction='vertical']:not(:first-child)) {
  margin-block-start: utility.wb-pixel-to-rem(-1px);
}

:host([direction='horizontal']:not(:last-child)) .wb-button::part(button) {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

:host([direction='horizontal']:not(:first-child)) .wb-button::part(button) {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

:host([direction='vertical']:not(:last-child)) .wb-button::part(button) {
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}

:host([direction='vertical']:not(:first-child)) .wb-button::part(button) {
  border-start-start-radius: 0;
  border-start-end-radius: 0;
}

:host([selected][theme='light']:not([disabled])) .wb-button::part(button) {
  &,
  &:focus,
  &:hover,
  &:active {
    cursor: default;
    animation: initial;
    background-color: var(--wb-black);
    border-color: var(--wb-grey-20);
    color: var(--wb-white);
  }
}

:host([selected][theme='dark']:not([disabled])) .wb-button::part(button) {
  &,
  &:focus,
  &:hover,
  &:active {
    cursor: default;
    animation: initial;
    background-color: var(--wb-white);
    border-color: var(--wb-grey-70);
    color: var(--wb-black);
  }
}

:host([selected]) .wb-button::part(button):focus,
:host([selected]) .wb-button::part(button):focus-within {
  box-shadow: 0 0 0 utility.wb-pixel-to-rem(1px) var(--focus-color) inset;
}

.wb-button {
  max-width: initial;
  width: 100%;
}

.wb-button[icon-only] {
  min-width: utility.wb-pixel-to-rem(56px);
}

.wb-button::part(button):focus,
.wb-button::part(button):focus-within {
  z-index: 1;
}
